import React from 'react';
import { useNavigate } from 'react-router-dom';

const cards = [
  { title: 'Student Attendance', route: '/', image: '/005-attendance.png' },
  { title: 'My Attendance', route: '/my-attendance', image: '/015-my-attendance.png' },
  { title: 'My Payroll (Shalarth)', route: '/my-payroll', image: '/008-money.png' },
  { title: 'Student Assessment', route: '/student-assessment', image: '/012-exam.png' },
  { title: 'Student Report Card', route: '/student-report', image: '/003-report-card.png' },
  { title: 'Timetable Management', route: '/timetable', image: '/004-timetable.png' },
  { title: 'LMS', route: '/lms', image: '/006-lms.png' },
  { title: 'CMS', route: '/cms', image: '/007-cms.png' },
  { title: 'Recruitment (Pavitra)', route: '/recruitment', image: '/004-search.png' },
  { title: 'My Profile', route: '/profile', image: '/001-profile.png' },
  { title: 'Teacher Training', route: '/training', image: '/014-training.png' }
];

export default function TeacherHome(){
  const navigate = useNavigate();
  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Welcome, Sameer Hapani</h2>
      <div className="grid grid-cols-3 lg:grid-cols-6 gap-4">
        {cards.map(c => (
          <div 
            key={c.title} 
            className="bg-white rounded-[0.5rem] shadow p-6 hover:shadow-md cursor-pointer flex flex-col items-center justify-center w-full" 
            onClick={() => {
              if(c.route === '/') navigate('/students'); else navigate(c.route);
            }}
          >
            <img 
              src={c.image} 
              alt="icon" 
              className="w-12 h-12 mb-3"
            />
            <div className="text-sm md:text-base font-medium text-gray-800 text-center">{c.title}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
